module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Mask-a47a51cdd0a3623bc708f3594d4e42a9.svg";